export abstract class ErrorCodes {
  static readonly Identity = {
    InvalidToken: 'Identity.InvalidToken',
    EmailAlreadyConfirmed: 'Identity.EmailAlreadyConfirmed',
  };

  static readonly ReAuth = {
    ReAuthenticate: 'reauthenticate',
  };
}
